import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { CreateWaveStep } from "@/types/waves.types";
import CreateWaveDates from "./dates/CreateWaveDates";
import type { CreateWaveDescriptionHandles } from "./description/CreateWaveDescription";
import CreateWaveDescription from "./description/CreateWaveDescription";
import CreateWaveDrops from "./drops/CreateWaveDrops";
import CreateWaveGroups from "./groups/CreateWaveGroups";
import type { useWaveConfig } from "./hooks/useWaveConfig";
import CreateWaveOutcomes from "./outcomes/CreateWaveOutcomes";
import CreateWaveOverview from "./overview/CreateWaveOverview";
import CreateWaveVoting from "./voting/CreateWaveVoting";
type WaveConfigController = ReturnType<typeof useWaveConfig>;
export default function CreateWaveStepContent(t0) {
  const $ = _c(73);
  const {
    controller,
    profile,
    descriptionRef,
    submitting,
    showDropError,
    onHaveDropToSubmitChange,
    onInlineGroupCreate
  } = t0;
  const {
    config,
    step,
    selectedOutcomeType,
    errors,
    groupsCache,
    isMemeCountLoading,
    isMemeCountError,
    setOverview,
    setDates,
    setDrops,
    setOutcomes,
    setDropsAdminCanDelete,
    onOutcomeTypeChange,
    onGroupSelect,
    onVotingTypeChange,
    onCategoryChange,
    onProfileIdChange,
    onCreditNftsChange,
    onCreditScopeChange,
    onMaxVotesPerIdentityPerDropChange,
    onAllowNegativeVotesChange,
    onTimeWeightedVotingChange,
    onThresholdChange,
    onThresholdTimeChange,
    onApprovalMaxWinnersChange,
    onChatEnabledChange
  } = controller;
  switch (step) {
    case CreateWaveStep.OVERVIEW:
      {
        let t1;
        if ($[0] !== config.overview || $[1] !== errors || $[2] !== setOverview) {
          t1 = <CreateWaveOverview overview={config.overview} errors={errors} setOverview={setOverview} />;
          $[0] = config.overview;
          $[1] = errors;
          $[2] = setOverview;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case CreateWaveStep.GROUPS:
      {
        let t1;
        if ($[4] !== config.chat.enabled || $[5] !== config.drops.adminCanDeleteDrops || $[6] !== config.groups || $[7] !== config.overview.name || $[8] !== config.overview.type || $[9] !== groupsCache || $[10] !== onChatEnabledChange || $[11] !== onGroupSelect || $[12] !== onInlineGroupCreate || $[13] !== setDropsAdminCanDelete) {
          t1 = <CreateWaveGroups waveName={config.overview.name} waveType={config.overview.type} groups={config.groups} groupsCache={groupsCache} chatEnabled={config.chat.enabled} adminCanDeleteDrops={config.drops.adminCanDeleteDrops} setChatEnabled={onChatEnabledChange} onGroupSelect={onGroupSelect} onInlineGroupCreate={onInlineGroupCreate} setDropsAdminCanDelete={setDropsAdminCanDelete} />;
          $[4] = config.chat.enabled;
          $[5] = config.drops.adminCanDeleteDrops;
          $[6] = config.groups;
          $[7] = config.overview.name;
          $[8] = config.overview.type;
          $[9] = groupsCache;
          $[10] = onChatEnabledChange;
          $[11] = onGroupSelect;
          $[12] = onInlineGroupCreate;
          $[13] = setDropsAdminCanDelete;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        return t1;
      }
    case CreateWaveStep.DATES:
      {
        let t1;
        if ($[15] !== config.dates || $[16] !== config.overview.type || $[17] !== errors || $[18] !== setDates) {
          t1 = <CreateWaveDates waveType={config.overview.type} dates={config.dates} errors={errors} setDates={setDates} />;
          $[15] = config.dates;
          $[16] = config.overview.type;
          $[17] = errors;
          $[18] = setDates;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case CreateWaveStep.DROPS:
      {
        let t1;
        if ($[20] !== config.drops || $[21] !== config.overview.type || $[22] !== errors || $[23] !== setDrops) {
          t1 = <CreateWaveDrops waveType={config.overview.type} drops={config.drops} errors={errors} setDrops={setDrops} />;
          $[20] = config.drops;
          $[21] = config.overview.type;
          $[22] = errors;
          $[23] = setDrops;
          $[24] = t1;
        } else {
          t1 = $[24];
        }
        return t1;
      }
    case CreateWaveStep.VOTING:
      {
        let t1;
        if ($[25] !== config.approval.threshold || $[26] !== config.approval.thresholdTimeMs || $[27] !== config.overview.type || $[28] !== config.voting.allowNegativeVotes || $[29] !== config.voting.category || $[30] !== config.voting.creditNftMemeCount || $[31] !== config.voting.creditNfts || $[32] !== config.voting.creditScope || $[33] !== config.voting.maxVotesPerIdentityPerDrop || $[34] !== config.voting.profileId || $[35] !== config.voting.timeWeighted || $[36] !== config.voting.type || $[37] !== errors || $[38] !== isMemeCountError || $[39] !== isMemeCountLoading || $[40] !== onAllowNegativeVotesChange || $[41] !== onCategoryChange || $[42] !== onCreditNftsChange || $[43] !== onCreditScopeChange || $[44] !== onMaxVotesPerIdentityPerDropChange || $[45] !== onProfileIdChange || $[46] !== onThresholdChange || $[47] !== onThresholdTimeChange || $[48] !== onTimeWeightedVotingChange || $[49] !== onVotingTypeChange) {
          t1 = <CreateWaveVoting waveType={config.overview.type} selectedType={config.voting.type} category={config.voting.category} profileId={config.voting.profileId} creditNfts={config.voting.creditNfts} creditScope={config.voting.creditScope} memeCount={config.voting.creditNftMemeCount} isMemeCountLoading={isMemeCountLoading} isMemeCountError={isMemeCountError} allowNegativeVotes={config.voting.allowNegativeVotes} maxVotesPerIdentityPerDrop={config.voting.maxVotesPerIdentityPerDrop} approvalThreshold={config.approval.threshold} approvalThresholdTimeMs={config.approval.thresholdTimeMs} errors={errors} onTypeChange={onVotingTypeChange} setCategory={onCategoryChange} setProfileId={onProfileIdChange} setCreditNfts={onCreditNftsChange} onCreditScopeChange={onCreditScopeChange} onAllowNegativeVotesChange={onAllowNegativeVotesChange} setMaxVotesPerIdentityPerDrop={onMaxVotesPerIdentityPerDropChange} setApprovalThreshold={onThresholdChange} setApprovalThresholdTimeMs={onThresholdTimeChange} timeWeighted={config.voting.timeWeighted} onTimeWeightedChange={onTimeWeightedVotingChange} />;
          $[25] = config.approval.threshold;
          $[26] = config.approval.thresholdTimeMs;
          $[27] = config.overview.type;
          $[28] = config.voting.allowNegativeVotes;
          $[29] = config.voting.category;
          $[30] = config.voting.creditNftMemeCount;
          $[31] = config.voting.creditNfts;
          $[32] = config.voting.creditScope;
          $[33] = config.voting.maxVotesPerIdentityPerDrop;
          $[34] = config.voting.profileId;
          $[35] = config.voting.timeWeighted;
          $[36] = config.voting.type;
          $[37] = errors;
          $[38] = isMemeCountError;
          $[39] = isMemeCountLoading;
          $[40] = onAllowNegativeVotesChange;
          $[41] = onCategoryChange;
          $[42] = onCreditNftsChange;
          $[43] = onCreditScopeChange;
          $[44] = onMaxVotesPerIdentityPerDropChange;
          $[45] = onProfileIdChange;
          $[46] = onThresholdChange;
          $[47] = onThresholdTimeChange;
          $[48] = onTimeWeightedVotingChange;
          $[49] = onVotingTypeChange;
          $[50] = t1;
        } else {
          t1 = $[50];
        }
        return t1;
      }
    case CreateWaveStep.APPROVAL:
      {
        return null;
      }
    case CreateWaveStep.OUTCOMES:
      {
        let t1;
        if ($[51] !== config.approval.maxWinners || $[52] !== config.dates || $[53] !== config.outcomes || $[54] !== config.overview.type || $[55] !== errors || $[56] !== onApprovalMaxWinnersChange || $[57] !== onOutcomeTypeChange || $[58] !== selectedOutcomeType || $[59] !== setOutcomes) {
          t1 = <CreateWaveOutcomes outcomes={config.outcomes} outcomeType={selectedOutcomeType} waveType={config.overview.type} errors={errors} dates={config.dates} maxWinners={config.approval.maxWinners} setOutcomeType={onOutcomeTypeChange} setOutcomes={setOutcomes} setMaxWinners={onApprovalMaxWinnersChange} />;
          $[51] = config.approval.maxWinners;
          $[52] = config.dates;
          $[53] = config.outcomes;
          $[54] = config.overview.type;
          $[55] = errors;
          $[56] = onApprovalMaxWinnersChange;
          $[57] = onOutcomeTypeChange;
          $[58] = selectedOutcomeType;
          $[59] = setOutcomes;
          $[60] = t1;
        } else {
          t1 = $[60];
        }
        return t1;
      }
    case CreateWaveStep.DESCRIPTION:
      {
        let t1;
        if ($[61] !== config.overview.image) {
          t1 = config.overview.image ? URL.createObjectURL(config.overview.image) : null;
          $[61] = config.overview.image;
          $[62] = t1;
        } else {
          t1 = $[62];
        }
        let t2;
        if ($[63] !== config.overview.name || $[64] !== t1) {
          t2 = {
            name: config.overview.name,
            image: t1,
            id: null
          };
          $[63] = config.overview.name;
          $[64] = t1;
          $[65] = t2;
        } else {
          t2 = $[65];
        }
        let t3;
        if ($[66] !== descriptionRef || $[67] !== onHaveDropToSubmitChange || $[68] !== profile || $[69] !== showDropError || $[70] !== submitting || $[71] !== t2) {
          t3 = <CreateWaveDescription ref={descriptionRef} profile={profile} submitting={submitting} showDropError={showDropError} wave={t2} onHaveDropToSubmitChange={onHaveDropToSubmitChange} />;
          $[66] = descriptionRef;
          $[67] = onHaveDropToSubmitChange;
          $[68] = profile;
          $[69] = showDropError;
          $[70] = submitting;
          $[71] = t2;
          $[72] = t3;
        } else {
          t3 = $[72];
        }
        return t3;
      }
  }
  return null;
}